import React from 'react';
import { HeadphonesIcon, SettingsIcon, CpuIcon } from 'lucide-react';
import { FadeUp } from './ui/FadeUp';
export function FeaturesSection() {
  const features = [{
    icon: HeadphonesIcon,
    title: 'HR Help Desk',
    description: 'Fast answers to everyday HR questions from real experts.'
  }, {
    icon: SettingsIcon,
    title: 'People Operations Execution',
    description: 'Policies, onboarding systems, documentation, and manager support handled for you.'
  }, {
    icon: CpuIcon,
    title: 'Operational HR Systems',
    description: 'Structured workflows and knowledge systems that keep HR organized and consistent.'
  }];
  return <section className="py-28 bg-white" data-id="element-40">
      <div className="max-w-[1240px] mx-auto px-8" data-id="element-41">
        <FadeUp className="text-center max-w-2xl mx-auto mb-16" data-id="element-42">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-43">
            HR support without building a full department
          </h2>
        </FadeUp>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-44">
          {features.map((feature, index) => <FadeUp key={index} delay={index * 0.1} data-id="element-45">
              <div className="bg-white rounded-xl p-8 border border-[#eee] shadow-[0_10px_30px_rgba(0,0,0,0.05)] hover:shadow-[0_10px_40px_rgba(0,0,0,0.08)] transition-all duration-300 h-full" data-id="element-46">
                <div className="w-12 h-12 rounded-xl bg-section-lavender flex items-center justify-center mb-6" data-id="element-47">
                  <feature.icon className="w-6 h-6 text-purple-500" data-id="element-48" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-49">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-50">
                  {feature.description}
                </p>
              </div>
            </FadeUp>)}
        </div>
      </div>
    </section>;
}